import { useDispatch, useSelector } from 'react-redux';
import { editComment, removeComment } from '../../store/Comments';
import { RootState } from '../../store/store';
import { ObjectToSync, UUID } from '../../types/types';
import { CookiesKeys, URLs } from "../../Constants/Consts";
import { SyncItemsTypes } from "./SyncItemsTypes";
import Cookies from "js-cookie";

export default function CommentsSync(): { getCommentsToSync: () => ObjectToSync[], updateSyncItem: (itemId: UUID) => void, cancelSyncItem: (itemId: UUID) => void } {
    const { Comments } = useSelector((state: RootState) => state.Comments)
    const dispatch = useDispatch()
    const getCommentsToSync = () => {
        const checklistItems = Comments.filter(c => c.notSync)
        const jwt = Cookies.get(CookiesKeys.jwt)
        return checklistItems.map(comment => {
            const url = !comment.creation ? URLs.putCommentsUrl(comment.commentUuid) : URLs.postCommentsUrl()
            const method = !comment.creation ? "PUT" : "POST"
            return {
                url,
                method,
                payload: comment,
                type: SyncItemsTypes.Comment,
                jwt,
                syncMeta: {
                    queueId: `comment:${comment.commentUuid}`,
                    itemId: comment.commentUuid,
                    itemLabel: comment.commentText,
                    resourceType: SyncItemsTypes.Comment,
                    localBaseTimestamp: comment.addedOn || null,
                    localUpdatedAt: new Date().toISOString(),
                }
            }
        })
    }
    const updateSyncItem = (itemId) => {
        const checklistItem = Comments.find(c => c.commentUuid.toLocaleUpperCase() === itemId?.toLocaleUpperCase?.())
        if (checklistItem?.commentUuid) dispatch(editComment({ ...checklistItem, notSync: false, creation: false }))
    }

    const cancelSyncItem = (itemId) => {
        const commentItem = Comments.find(c => c.commentUuid.toLocaleUpperCase() === itemId?.toLocaleUpperCase?.())
        if (!commentItem?.commentUuid) return

        if (commentItem.creation) {
            dispatch(removeComment(commentItem.commentUuid))
            return
        }

        dispatch(editComment({
            ...commentItem,
            commentText: commentItem.previousCommentText ?? commentItem.commentText,
            notSync: false,
            creation: false,
            previousCommentText: undefined,
        }))
    }

    return {
        getCommentsToSync, updateSyncItem, cancelSyncItem
    }
}
